import { render, staticRenderFns } from "./Organizations.vue?vue&type=template&id=6616efb6"
import script from "./Organizations.vue?vue&type=script&lang=js"
export * from "./Organizations.vue?vue&type=script&lang=js"
import style0 from "./Organizations.vue?vue&type=style&index=0&id=6616efb6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports